import SearchWidget from "./SearchWidget";
import { Link } from "react-router-dom";
import { Star, Shield, Tag, Globe2 } from "lucide-react";

const HERO_BG = "https://static.prod-images.emergentagent.com/jobs/36fdd33c-c728-4296-ac4e-4f02e1611b32/images/0c4ab609131d4960e58e4ec3a4771fcf88192c0f60548faa89c08945c37a19aa.png";

export default function Hero() {
  return (
    <section data-testid="hero" className="relative">
      <div className="relative h-[640px] md:h-[720px] overflow-hidden">
        <img
          src={HERO_BG}
          alt="Travel essentials laid out"
          className="absolute inset-0 w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 hero-overlay" />
        <div className="container-page relative z-10 h-full flex items-center pt-10">
          <div className="max-w-2xl text-white">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 text-xs uppercase tracking-widest mb-6">
              <Star size={14} className="text-accent" /> Trusted by 1M+ travellers
            </div>
            <h1 className="font-montserrat font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Find the Best <span className="text-accent">Travel Deals</span> Worldwide
            </h1>
            <p className="mt-5 text-base md:text-lg text-white/85 max-w-xl leading-relaxed">
              Compare flights, hotels and travel offers from leading partners — and save more on every journey.
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link to="/flights" data-testid="hero-search-flights">
                <button className="h-12 px-6 rounded-lg btn-accent font-semibold text-sm uppercase tracking-wider">
                  Search Flights
                </button>
              </Link>
              <Link to="/deals" data-testid="hero-explore-deals">
                <button className="h-12 px-6 rounded-lg bg-white text-brand font-semibold text-sm uppercase tracking-wider hover:bg-brand-50 transition-colors">
                  Explore Deals
                </button>
              </Link>
            </div>

            <div className="mt-10 hidden md:flex items-center gap-6 text-sm text-white/80">
              <div className="flex items-center gap-2"><Shield size={16} className="text-accent" /> Secure bookings</div>
              <div className="flex items-center gap-2"><Tag size={16} className="text-accent" /> Best price guarantee</div>
              <div className="flex items-center gap-2"><Globe2 size={16} className="text-accent" /> 100+ destinations</div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-page relative -mt-24 md:-mt-28 z-20 pb-12">
        <SearchWidget />
      </div>
    </section>
  );
}
